import { IconProps } from './IconProps';

export const LinkedinWhite = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Combined Shape</title>
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="icon-/-16-/-social-/-LinkedIn" fill="#FFFFFF" fillRule="nonzero">
          <path
            d="M14.0357132,2.66453526e-15 C15.1205588,2.46525235e-15 16,0.879441161 16,1.96428681 L16,14.0357132 C16,15.1205588 15.1205588,16 14.0357132,16 L1.96428681,16 C0.879441161,16 -6.52848287e-15,15.1205588 -7.10542736e-15,14.0357132 L-7.10542736e-15,1.96428681 C-7.23828263e-15,0.879441161 0.879441161,3.30790738e-15 1.96428681,2.66453526e-15 L14.0357132,2.66453526e-15 Z M8.52173913,6 L6.26086957,6 L6.26086957,14 L8.69565217,14 L8.69565217,10.2292174 C8.69565217,8.93043478 9.17391304,8.10434783 10.3234783,8.10434783 C11.1523478,8.10434783 11.4782609,8.8706087 11.4782609,10.2292174 L11.4782609,10.2292174 L11.4782609,14 L13.9130435,14 L13.9130435,9.68591304 C13.9130435,7.30017391 13.3422609,6 10.9373913,6 C9.68278261,6 8.84765217,6.58713043 8.52173913,7.24034783 L8.52173913,7.24034783 L8.52173913,6 Z M4.52173913,6 L2.08695652,6 L2.08695652,14 L4.52173913,14 L4.52173913,6 Z M3.33521168,1.91110375 C2.52157745,1.91110375 1.86199657,2.57068462 1.86199657,3.38431885 C1.86199657,4.19795309 2.52157745,4.85753396 3.33521168,4.85753396 C4.14884592,4.85753396 4.80842679,4.19795309 4.80842679,3.38431885 C4.80842679,2.57068462 4.14884592,1.91110375 3.33521168,1.91110375 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </svg>
  );
};

